<script setup lang="ts">
import AccountsPage from '../features/accounts/AccountsPage.vue';
</script>

<template>
  <AccountsPage />
</template>
